import { c as _c } from "react/compiler-runtime";
import type { EditorProps, Monaco } from "@monaco-editor/react";
import { Box, Skeleton, useColorScheme } from "@mui/material";
import type { editor } from "monaco-editor";
import dynamic from "next/dynamic";
import React from "react";
import { useMobileLayout } from "#/shared/hooks/useMobileLayout";
const MonacoEditor = dynamic(() => import("@monaco-editor/react"), {
  ssr: false,
  loading: () => <Skeleton variant="rectangular" height="400px" />
});
type CodeRunnerProps = EditorProps & {
  isUpdating?: boolean;
  setMonacoInstance?: React.Dispatch<React.SetStateAction<Monaco | null>>;
  setEditorInstance?: React.Dispatch<React.SetStateAction<editor.IStandaloneCodeEditor | null>>;
  setTextModel: React.Dispatch<React.SetStateAction<editor.ITextModel | null>>;
};
export const CodeRunner: React.FC<CodeRunnerProps> = t0 => {
  const $ = _c(25);
  let height;
  let restProps;
  let setEditorInstance;
  let setMonacoInstance;
  let setTextModel;
  if ($[0] !== t0) {
    ({
      setMonacoInstance,
      setEditorInstance,
      setTextModel,
      height,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = restProps;
    $[3] = setEditorInstance;
    $[4] = setMonacoInstance;
    $[5] = setTextModel;
  } else {
    height = $[1];
    restProps = $[2];
    setEditorInstance = $[3];
    setMonacoInstance = $[4];
    setTextModel = $[5];
  }
  const {
    mode
  } = useColorScheme();
  const isMobile = useMobileLayout();
  const t1 = height === "100%" ? "100%" : undefined;
  let t2;
  if ($[6] !== t1) {
    t2 = {
      position: "relative",
      height: t1
    };
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = mode === "dark" ? "app-dark" : "vs-light";
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      enabled: false
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = !isMobile;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      enabled: false
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = {
      fontSize: 13,
      minimap: t4,
      tabSize: 2,
      fixedOverflowWidgets: true,
      lineNumbersMinChars: 3,
      lineDecorationsWidth: 6,
      folding: t5,
      stickyScroll: t6,
      wordWrap: "on"
    };
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = typeof height === "number" ? `calc(${height}px - 6vh)` : height;
  let t9;
  if ($[12] !== setEditorInstance || $[13] !== setMonacoInstance || $[14] !== setTextModel) {
    t9 = (editor, monaco) => {
      const model = editor.getModel();
      if (!model) {
        console.error("No model found");
        return;
      }
      setEditorInstance?.(editor);
      setMonacoInstance?.(monaco);
      setTextModel(model);
      monaco.editor.defineTheme("app-dark", {
        base: "vs-dark",
        inherit: true,
        rules: [],
        colors: {
          "editor.background": "#00000000",
          focusBorder: "#00000000"
        }
      });
      monaco.editor.setTheme("app-dark");
    };
    $[12] = setEditorInstance;
    $[13] = setMonacoInstance;
    $[14] = setTextModel;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== restProps || $[17] !== t3 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t10 = <MonacoEditor theme={t3} options={t7} {...restProps} height={t8} onMount={t9} />;
    $[16] = restProps;
    $[17] = t3;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t2) {
    t11 = <Box sx={t2}>{t10}</Box>;
    $[22] = t10;
    $[23] = t2;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};